import { render, staticRenderFns } from "./HeaderSass.vue?vue&type=template&id=f3a481ca&"
import script from "./HeaderSass.vue?vue&type=script&lang=js&"
export * from "./HeaderSass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports